import {Component, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {HttpClient} from "@angular/common/http";
import {TaskStatus, TasksV1Service, Department, EmployeesV1Service} from "../../../apis/backend";
import {firstValueFrom, Observable} from "rxjs";

@Component({
    selector: 'department-dialog',
    templateUrl: './department-dialog.component.html',
})
export class DepartmentDialogComponent implements OnInit {
    
    public Departments: Department[];
    
    public NewDepartmentName: string;
    
    constructor(public ActiveModal: NgbActiveModal,
                public HttpService: HttpClient,
                public EmployeeService: EmployeesV1Service) {
    }
    
    ngOnInit(): void {
        firstValueFrom(this.EmployeeService.getDepartments())
            .then(departments => this.Departments = departments
                .sort((d1, d2) => d1.Name.localeCompare(d2.Name)));
    }
    
    AddDepartment() {
        if (this.NewDepartmentName) {
            this.Departments.push({
                DepartmentID: 0,
                Name: this.NewDepartmentName
            });
            this.NewDepartmentName = "";
        }
    }

    public Save() {
        firstValueFrom(this.EmployeeService.syncDepartments(this.Departments))
            .then(() => this.ActiveModal.close());
    }

    public Cancel() {
        this.ActiveModal.dismiss();
    }
}